import { memo, useMemo } from "react";

import classesCell from './BodyCell.module.css'
import { atpProvidersOptions } from "../../../lib/systemData"

let providerLabelByValue = null;

function getProviderLabelByValue() {
    if (providerLabelByValue) {
        return providerLabelByValue;
    }
    const options = atpProvidersOptions() || [];
    const map = new Map();
    options.forEach((item) => {
        map.set(String(item.value), item.label);
    });
    providerLabelByValue = map;
    return map;
}

function ProviderCell({data, itemKey}) {
    const text = useMemo(() => {
        if (itemKey !== 'work_comp_atp_provider') {
            return null;
        }
        const byValue = getProviderLabelByValue();
        return byValue.get(String(data)) ?? null;
    }, [itemKey, data]);


    // old code
    // const [text, setText] = useState(null)

    // useEffect(() => {
    //     if (itemKey == 'work_comp_atp_provider') {

    //         let options = atpProvidersOptions()
    //         if (options) {
    //             let item = options.find(item => item.value == data)
    //             if (item) {
    //                 setText(item.label)
    //             }
    
    //         }
            
    //     }

        
        
    // }, [data, itemKey])

    return <div className={`${classesCell.body_cell} `}>
        {text}
    </div>
}

function providerCellPropsEqual(prevProps, nextProps) {
    return prevProps.itemKey === nextProps.itemKey && prevProps.data === nextProps.data;
}

export default memo(ProviderCell, providerCellPropsEqual);